import React, {Fragment} from 'react';
import Dotdotdot from 'react-dotdotdot';
import LazyLoad from 'react-lazyload';

import Link from '../../../shared/components/hyperlink';
import ImageWithPlaceholder from '../../../shared/components/image-with-placeholder';
import { Helpers } from '../../../core/src/helpers';
import PurchaseButton from '../../../product/components/purchase-button-container';
import ProductPrice from '../../../product/components/product-price';
import { PartialDataAdd } from '../../../caching/partial-data-store';

import '../../css/pdp-xsell.less';

export default ({ product, setCarouselHeight, showImage=true }) => {
    const imageUrl = Helpers.getCDNUrl(product.images[0].cdn,product.images[0].lrg, 300);
    const productUrl = `/pdp/${product.slug}`;
    return (
        <PartialDataAdd 
            cacheKey={product.slug} 
            cacheValue={product} 
            schema={'product'}
            className={'pdp-xsell'}
        >
                {
                    showImage && 
                    <LazyLoad height={140} once={true} offset={100}>
                         <ImageWithPlaceholder className='pdp-xsell-image' src={imageUrl} onLoad={setCarouselHeight}/>
                    </LazyLoad>
                }
                <Link className='pdp-xsell-title' to={productUrl}>
                    <h3 title={product.name.length >= 40 ? product.name : undefined}>
                        {product.name}
                    </h3>
                </Link>
                <Dotdotdot className='ksps' clamp={5}>
                    {product.ksps.map( (ksp, i) => <Fragment key={i}>•{`  ${ksp}`}<br/></Fragment>)}
                </Dotdotdot>
                <ProductPrice product={product} />
                <PurchaseButton product={product} />
                <br/>
                <Link className='pdp-xsell-link' to={productUrl}>View Details</Link>
        </PartialDataAdd>
    )
}
